/** @format */

import { ActionKind, SupplierViewPropsTypes } from "../SupplierViewPropsTypes";
import images from "../../ImageVariables";
import "../SCSS/styles.css";
import {
  parseISO,
  differenceInCalendarDays,
  getDate,
  getMonth,
  getYear,
} from "date-fns";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import icons from "../../Assets/Icons/icons";
import Tippy from "@tippyjs/react";
import "tippy.js/themes/light.css";
import SurveyExpirationPage from "../../SurveyExpirationPage";
import DeactivatePage from "../../DeactivatePage";

import {
  AssessmentName,
  AssessmentType,
  EnumQuestionType,
  EnumSurveyAnswerStatus,
  EnumTypeTexts,
  ImpactRiskResponse,
  TemplateNameEnum,
  manuplateSurveyStatus,
} from "../../Common/Enums/EnumsTypes";
import { Navigate } from "react-router-dom";
import { truncateString } from "../../Common/CommonFunctions/TruncateString";
import DOMPurify from "dompurify";
import CheckBox from "../../QuestionTypesComponent/Checkbox";
import Radio from "../../QuestionTypesComponent/Radio";
import StarRating from "../../QuestionTypesComponent/StarRating";
import DropDown from "../../QuestionTypesComponent/DropDown";
import TextBox from "../../QuestionTypesComponent/TextBox";
import Number from "../../QuestionTypesComponent/Number";
import Matrix from "../../QuestionTypesComponent/Matrix";
import DateAndTime from "../../QuestionTypesComponent/DateAndTime";
import FileUpload from "../../QuestionTypesComponent/FileUpload";
import Percentage from "../../QuestionTypesComponent/Percentage";
import CustomForm from "../../QuestionTypesComponent/CustomForm";
import { Circles } from "react-loader-spinner";
import { showFileSvg } from "../../Common/CommonFunctions/useFileIconSrc";
import { UpdaptButton, UpdaptTextArea } from "@updapt/updapt-core";
import { scmNameHash } from "../../Common/scmNameVaribale";
import {
  check,
  generateMessage,
} from "../../Common/CommonFunctions/MandatoryMessageGenerator";
import { cleanText } from "../../Common/CommonFunctions/cleanText";

function SupplierView({
  removeAttachedFile,
  handleNoteComment,
  surveyAnswersInfo,
  surveyAnswers,
  handleChangeAddComment,
  handleChangeClearComment,
  SaveAsDraft,
  reducerState,
  questionObjVariable,
  isPreview,
  monthsHash,
  confirmSubmit,
  confirmDeleteFile,
  dispatch,
  params,
  handleClearAnswer,
  mainRefObject,
  dependencyAnsHash,
  setDependencyAnsHash,
  setSurveyAnswers,
  clearValuesFromSurveyAnswers,
  checkNestedDependency,
  oldOption,
  questionIdRefs,
  isSurveyLoaded,
  downloadAttachmentFile,
  getBaseSurveyAnswer,
  handlePastResponseViewChange,
  isPastResponseView,
  taggedSurveyNotAnsweredNote,
  handleNotApplicableToggle,
  handleNotApplicableNote,
  setIsHoveredLabel,
  isHoveredLabel,
  questionIndexMap,
}: SupplierViewPropsTypes) {
  // const getAttachmentNoteInfo = (
  //   questionId: string,
  //   attachmentOptions: Array<string>,
  //   noteOptions: Array<string>
  // ) => {
  //   let hasAttachmentOption = false,
  //     hasNoteOption = false,
  //     attachmentOptionName = "",
  //     noteOptionName = "";

  //   if (
  //     attachmentOptions.some(
  //       (ele: any) => surveyAnswers[questionId]?.optionId === ele
  //     ) &&
  //     questionObjVariable[questionId]?.optionInfo?.optionObj[
  //       surveyAnswers[questionId]?.optionId!
  //     ].optionName
  //   ) {
  //     hasAttachmentOption = true;
  //     attachmentOptionName =
  //       questionObjVariable[questionId]?.optionInfo?.optionObj[
  //         surveyAnswers[questionId]?.optionId!
  //       ].optionName;
  //   }

  //   if (
  //     noteOptions.some(
  //       (ele: any) => surveyAnswers[questionId]?.optionId === ele
  //     ) &&
  //     questionObjVariable[questionId]?.optionInfo?.optionObj[
  //       surveyAnswers[questionId]?.optionId!
  //     ].optionName
  //   ) {
  //     hasNoteOption = true;
  //     noteOptionName =
  //       questionObjVariable[questionId]?.optionInfo?.optionObj[
  //         surveyAnswers[questionId]?.optionId!
  //       ].optionName;
  //   }

  //   return {
  //     hasAttachmentOption,
  //     hasNoteOption,
  //     attachmentOptionName,
  //     noteOptionName,
  //   };
  // };
  // const messageGenerator = (
  //   encodedState: number,
  //   attachmentOptions: Array<string>,
  //   questionId: string,
  //   noteOptions: Array<string>,
  //   isAttachmentMandatoryForQuestion: boolean,
  //   isNoteMandatoryForQuestion: boolean
  // ) => {
  //   const {
  //     hasAttachmentOption,
  //     hasNoteOption,
  //     attachmentOptionName,
  //     noteOptionName,
  //   } = getAttachmentNoteInfo(questionId, attachmentOptions, noteOptions);

  //   switch (encodedState) {
  //     case 0:
  //     case 1:
  //       return "";

  //     case 2:
  //       return (
  //         <div className="mandatory">
  //           <span className="mandatory-child"> Attachment is Mandatory.</span>
  //         </div>
  //       );
  //     case 3:
  //       return (
  //         <div className="mandatory">
  //           <span className="mandatory-child"> Attachment is Mandatory.</span>
  //         </div>
  //       );
  //     case 4:
  //       return (
  //         <div className="mandatory">
  //           <span className="mandatory-child">
  //             Attachment is mandatory for{" "}
  //             <span className="mandatory-child-option-name-cover">
  //               {attachmentOptions.some(
  //                 (ele) => surveyAnswers[questionId].optionId === ele
  //               ) &&
  //                 questionObjVariable[questionId].optionInfo.optionObj[
  //                   surveyAnswers[questionId].optionId!
  //                 ].optionName}
  //             </span>
  //             .
  //           </span>
  //         </div>
  //       );
  //     case 5:
  //       return (
  //         <div className="mandatory">
  //           <span className="mandatory-child">
  //             Attachment is mandatory for{" "}
  //             <span className="mandatory-child-option-name-cover">
  //               {attachmentOptions.some(
  //                 (ele) => surveyAnswers[questionId].optionId === ele
  //               ) &&
  //                 questionObjVariable[questionId].optionInfo.optionObj[
  //                   surveyAnswers[questionId].optionId!
  //                 ].optionName}
  //             </span>
  //             .{" "}
  //           </span>
  //         </div>
  //       );
  //     case 6:

  //     case 7:
  //     case 8:
  //     case 9:
  //       return "";

  //     case 10:
  //     case 11:
  //     case 12:
  //     case 13:
  //     case 14:
  //     case 15:
  //       let attachmentMessage = "",
  //         noteMessage = "";

  //       if (isAttachmentMandatoryForQuestion) {
  //         attachmentMessage = "Attachment is mandatory.";
  //       }
  //       if (isNoteMandatoryForQuestion) {
  //         noteMessage = "Note is Mandatory.";
  //       }

  //       if (hasNoteOption) {
  //         noteMessage = `Note is mandatory for ${noteOptionName.toUpperCase()}`;
  //       }
  //       if (hasAttachmentOption) {
  //         attachmentMessage = `Attachment is mandatory for ${attachmentOptionName.toUpperCase()}`;
  //       }

  //       return (
  //         <div className="mandatory">
  //           {attachmentMessage && (
  //             <span className="mandatory-child">
  //               {noteMessage && "1. "}
  //               {attachmentMessage}
  //             </span>
  //           )}
  //           {noteMessage && (
  //             <span className="mandatory-child">
  //               {attachmentMessage && "2. "}
  //               {noteMessage}
  //             </span>
  //           )}
  //         </div>
  //       );

  //     case 16:
  //     case 17:
  //       return (
  //         <div className="mandatory">
  //           <span className="mandatory-child">
  //             1. Attachment is mandatory for{" "}
  //             {attachmentOptionName.toUpperCase()}
  //           </span>
  //           <span className="mandatory-child">
  //             2. Note is mandatory for {noteOptionName.toUpperCase()}
  //           </span>
  //         </div>
  //       );
  //     default:
  //       break;
  //   }
  // };
  // const check = (options: Array<string>, questionId: string) => {

  //   if (!options.length) return { visible: false, value: 0 };
  //   for (const opt of options) {
  //     if (opt === surveyAnswers?.[questionId]?.optionId) {
  //       return { visible: true, value: 4 };
  //     }
  //   }
  //   return { visible: false, value: 0 }; // Ensure to return false if no conditions match
  // };
  // function encodeStates(
  //   questionId: string,
  //   isQuestionMandatory: boolean,
  //   isAttachmentMandatoryForQuestion: boolean,
  //   isAttachmentMandatoryForOptions: boolean,
  //   isNoteMandatory: boolean,
  //   attachmentOptions: Array<string>,
  //   noteOptions: Array<string>,
  //   isNoteMandatoryForQuestion: boolean,
  //   isNoteMandatoryForOptions: boolean
  // ) {
  //   return (
  //     (isQuestionMandatory ? 1 : 0) +
  //     (isAttachmentMandatoryForQuestion ? 2 : 0) +
  //     (isAttachmentMandatoryForOptions
  //       ? check(attachmentOptions, questionId).value
  //       : 0) +
  //     (isNoteMandatory ? 8 : 0) +
  //     (isNoteMandatoryForQuestion ? 2 : 0) +
  //     (isNoteMandatoryForOptions ? check(noteOptions, questionId).value : 0)
  //   );
  // }
  // function generateMessage(
  //   questionId: string,
  //   isQuestionMandatory: boolean,
  //   isAttachmentMandatoryForQuestion: boolean,
  //   isAttachmentMandatoryForOptions: boolean,
  //   attachmentOptions: Array<string>,
  //   isNoteMandatory: boolean,
  //   noteOptions: Array<string>,
  //   isNoteMandatoryForQuestion: boolean,
  //   isNoteMandatoryForOptions: boolean
  // ) {
  //   const encodedState: number = encodeStates(
  //     questionId,
  //     isQuestionMandatory,
  //     isAttachmentMandatoryForQuestion,
  //     isAttachmentMandatoryForOptions,
  //     isNoteMandatory,
  //     attachmentOptions,
  //     noteOptions,
  //     isNoteMandatoryForQuestion,
  //     isNoteMandatoryForOptions
  //   );

  //   const message = messageGenerator(
  //     encodedState,
  //     attachmentOptions,
  //     questionId,
  //     noteOptions,
  //     isAttachmentMandatoryForQuestion,
  //     isNoteMandatoryForQuestion
  //   );
  //   return message;
  // }
  const regex = /<\/?[^>]+(>|$)|&nbsp;|&amp;/g;
  function renderQuestions(questionId: string) {
    switch (questionObjVariable?.[questionId]?.questionType) {
      case EnumQuestionType?.CHECKBOX:
        return (
          <CheckBox
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            surveyAnswers={surveyAnswers}
            isPreview={isPreview}
            setSurveyAnswers={setSurveyAnswers}
            mainRefObject={mainRefObject}
            clearValuesFromSurveyAnswers={clearValuesFromSurveyAnswers}
            checkNestedDependency={checkNestedDependency}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            reducerState={reducerState}
            dispatch={dispatch}
            surveyAnswersInfo={surveyAnswersInfo}
            // clearAllFiles={clearAllFiles}
          />
        );

      case EnumQuestionType?.RADIO:
        return (
          <Radio
            oldOption={oldOption}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            checkNestedDependency={checkNestedDependency}
            isPreview={isPreview}
            mainRefObject={mainRefObject}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            reducerState={reducerState}
            dispatch={dispatch}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.RATING:
        return (
          <StarRating
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.DROP_DOWN:
        return (
          <DropDown
            oldOption={oldOption}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            isPreview={isPreview}
            questionObjVariable={questionObjVariable}
            questionId={questionId}
            mainRefObject={mainRefObject}
            checkNestedDependency={checkNestedDependency}
            dependencyAnsHash={dependencyAnsHash}
            setDependencyAnsHash={setDependencyAnsHash}
            reducerState={reducerState}
            dispatch={dispatch}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.TEXT:
        return (
          <TextBox
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.NUMBER:
        return (
          <Number
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
            dispatch={dispatch}
            reducerState={reducerState}
          />
        );
      case EnumQuestionType.MATRIX:
        return (
          <Matrix
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.DATE:
        return (
          <DateAndTime
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
          />
        );
      case EnumQuestionType.FILE:
        return (
          <FileUpload
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswersInfo={surveyAnswersInfo}
            reducerState={reducerState}
            dispatch={dispatch}
            removeAttachedFile={removeAttachedFile}
            surveyAnswers={surveyAnswers}
          />
        );
      case EnumQuestionType.PERCENTAGE:
        return (
          <Percentage
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            questionObjVariable={questionObjVariable}
            surveyAnswersInfo={surveyAnswersInfo}
            dispatch={dispatch}
            reducerState={reducerState}
          />
        );
      case EnumQuestionType.CUSTOM_FORM:
        return (
          <CustomForm
            questionId={questionId}
            isPreview={isPreview}
            surveyAnswersInfo={surveyAnswersInfo}
            dispatch={dispatch}
            surveyAnswers={surveyAnswers}
          />
        );
      default:
        return null;
    }
  }
  const percentage =
    surveyAnswersInfo?.surveyScoreInfo &&
    surveyAnswersInfo?.surveyInfo?.additionalInfo?.enableScoreNormalization
      ? parseFloat(surveyAnswersInfo?.surveyScoreInfo?.score.toFixed(2)) * 10
      : (parseFloat(surveyAnswersInfo?.surveyScoreInfo?.score.toFixed(2)) /
          parseFloat(
            surveyAnswersInfo?.surveyScoreInfo?.totalMaxWeightage.toFixed(2)
          )) *
        100;

  const currentStatusColor: { [key: string]: string } = {
    completed: "#029B6C",
    rejected: "#EE5F5F",
    pending: "#F7A22F",
    saved_as_draft: "#F7A22F",
  };

  function borderColorForStatus(surveyStatus: string) {
    if (surveyStatus === EnumSurveyAnswerStatus.COMPLETED) {
      return `1px solid #1EBF9C`;
    } else if (
      surveyStatus === EnumSurveyAnswerStatus.PENDING ||
      surveyStatus === EnumSurveyAnswerStatus.SAVED_AS_DRAFT
    ) {
      return `1px solid #F7A22F`;
    } else {
      return `1px solid #EE5F5F`;
    }
  }

  function backgroundColorForStatus(surveyStatus: string) {
    if (surveyStatus === EnumSurveyAnswerStatus.COMPLETED) {
      return `#e8f8f4`;
    } else if (
      surveyStatus === EnumSurveyAnswerStatus.PENDING ||
      surveyStatus === EnumSurveyAnswerStatus.SAVED_AS_DRAFT
    ) {
      return `#FFFAF3`;
    } else {
      return `#FDEEEE`;
    }
  }
  const currentImpactColor: { [key: string]: string } = {
    low: "#03986b",
    medium: "#deca06",
    high: "#ec9a1f",
    extreme: "#ce3535",
  };
  function borderColorForImpact(imapct: string) {
    if (imapct === ImpactRiskResponse.LOW) {
      return `1px solid #d9f4eb`;
    } else if (imapct === ImpactRiskResponse.MEDIUM) {
      return `1px solid #fffde9`;
    } else if (imapct === ImpactRiskResponse.HIGH) {
      return `1px solid #fcefdc`;
    } else {
      return `1px solid #f7e0e0`;
    }
  }
  function backgroundColorForImpact(imapct: string) {
    if (imapct === ImpactRiskResponse.LOW) {
      return `#d9f4eb`;
    } else if (imapct === ImpactRiskResponse.MEDIUM) {
      return `#fffde9`;
    } else if (imapct === ImpactRiskResponse.HIGH) {
      return `#fcefdc`;
    } else {
      return `#f7e0e0`;
    }
  }

  function differenceInDaysCalcultor(endDate: Date) {
    const days = differenceInCalendarDays(new Date(endDate), new Date());
    return days > 0 ? days : 0;
  }

  const notes = surveyAnswersInfo?.surveyInfo?.additionalInfo?.note.split("\n");

  return (
    <>
      {(!isSurveyLoaded && isPreview) || reducerState.apiLoading ? (
        <div className="loader-container-supplier-view">
          <Circles
            height="80"
            width="80"
            color="#4fa94d"
            ariaLabel="circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
          <span style={{ fontSize: "16px" }}>
            {`${
              isPreview
                ? "Loading..."
                : `${
                    (surveyAnswersInfo?.companyInfo?.scmName &&
                      scmNameHash[surveyAnswersInfo?.companyInfo?.scmName]) ??
                    AssessmentName.ASSESSMENT
                  } is submitting,this may take a while. Please wait`
            }`}
          </span>
        </div>
      ) : (
        <>
          {params ||
          surveyAnswersInfo?.surveyStatus !==
            EnumSurveyAnswerStatus?.COMPLETED ? (
            <div className="supplier-view-main-container">
              {((isPreview &&
                !surveyAnswersInfo?.surveyInfo?.endDate &&
                surveyAnswersInfo?.activated) ||
                (surveyAnswersInfo?.activated &&
                  differenceInDaysCalcultor(
                    surveyAnswersInfo?.surveyInfo?.endDate
                  ) > 0)) && (
                <>
                  <div className="supplier-view-main-question-outer-cover">
                    <div className="supplier-view-company-info-cover">
                      <div className="supplier-view-company-info-wrapper">
                        <div className="logo-main-cover">
                          <div className="logo-cover">
                            <img
                              height={"60px"}
                              src={
                                surveyAnswersInfo?.companyInfo?.additionalInfo
                                  ?.companyLogoUrl
                              }
                              alt="LOGO"
                            ></img>
                          </div>
                        </div>
                        <div className="description-main-cover">
                          <div className="description-cover">
                            {" "}
                            {surveyAnswersInfo?.companyInfo?.description}
                          </div>
                        </div>
                        <div className="address-cover">
                          <span className="loc-icon">
                            <img
                              style={{ width: "1em", height: "1em" }}
                              src={images.location}
                              alt="location"
                            />
                          </span>
                          <span className="address">
                            {surveyAnswersInfo?.companyInfo?.address}
                          </span>
                        </div>
                        <div className="contact-cover">
                          <span className="phone-icon">
                            <img
                              style={{ width: "1em" }}
                              src={images.phoneIcon}
                              alt="phoneIcon"
                            />
                          </span>
                          <span className="phone-number">
                            {surveyAnswersInfo?.companyInfo?.countryCode > 0 &&
                              "+"}
                            {surveyAnswersInfo?.companyInfo?.countryCode}{" "}
                            {surveyAnswersInfo?.companyInfo?.phoneNumber}
                          </span>
                          <div className="icon-url-cover">
                            <span className="icon">
                              <img
                                style={{ width: "1em" }}
                                src={images.mailIcon}
                                alt="mail"
                              />
                            </span>
                            <span className="url">
                              {surveyAnswersInfo?.companyInfo?.companyUrl}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="supplier-view-supplier-info-cover">
                      <div className="supplier-view-supplier-info-wrapper">
                        <div className="supplier-info-logo-cover">
                          <img
                            className="group-logo"
                            src={images.Group}
                            alt="supplier-view-group-logo"
                          />
                        </div>
                        <div className="supplier-info-supplier-name-industry-cover">
                          <div className="supplier-info-supplier-name-cover">
                            <span className="supplier-name-static-text">
                              <span style={{ marginRight: "5px" }}>
                                {` ${
                                  surveyAnswersInfo?.companyInfo?.scmName ??
                                  "Supplier"
                                }`}
                              </span>
                              Name :
                            </span>
                            <span className="supplier-name-dynamic-text">
                              {
                                surveyAnswersInfo?.supplierInfo?.companyDetails
                                  ?.companyName
                              }
                            </span>
                          </div>
                          <div className="supplier-info-supplier-industry-cover">
                            <span className="supplier-industry-type-static-text">
                              Industry type :
                            </span>
                            <span className="supplier-industry-type-dynamic-text">
                              {
                                surveyAnswersInfo?.supplierInfo?.companyDetails
                                  ?.industryName
                              }
                            </span>
                          </div>

                          {/* <div className="current-status-cover">
                            <span
                              style={{
                                color: "#5e5e5e",
                                fontSize: "18px",
                                fontWeight: "500",
                                display: "flex",
                                justifyContent: "end",
                                width: "145px",
                              }}
                            >
                              Status :
                            </span>

                            <span
                              style={{
                                color:
                                  currentStatusColor?.[
                                    surveyAnswersInfo?.surveyStatus
                                  ],
                                marginLeft: `${
                                  manuplateSurveyStatus[
                                    surveyAnswersInfo?.surveyStatus
                                  ] !== "-"
                                    ? "10px"
                                    : "1px"
                                }`,
                                fontSize: "14px",
                                fontWeight: "500",
                                padding: "5px 10px",
                                borderRadius: "5px",
                                border: `${
                                  manuplateSurveyStatus[
                                    surveyAnswersInfo?.surveyStatus
                                  ] !== "-" &&
                                  borderColorForStatus(
                                    surveyAnswersInfo?.surveyStatus
                                  )
                                }`,
                                background: `${
                                  manuplateSurveyStatus[
                                    surveyAnswersInfo?.surveyStatus
                                  ] !== "-" &&
                                  backgroundColorForStatus(
                                    surveyAnswersInfo?.surveyStatus
                                  )
                                }`,
                              }}
                            >
                              {manuplateSurveyStatus[
                                surveyAnswersInfo?.surveyStatus
                              ]
                                ?.charAt(0)
                                .toUpperCase()}
                              {manuplateSurveyStatus[
                                surveyAnswersInfo?.surveyStatus
                              ]?.slice(1)}
                            </span>
                          </div> */}
                        </div>
                        <div className="survey-end-date-cover">
                          <div className="end-date-cover-wrapper">
                            <div className="end-date-text-cover">
                              <div className="end-date-text">
                                Assessment End Date
                              </div>
                            </div>
                            <div className="end-date-number-cover">
                              <div className="end-date-number-wrapper">
                                <div className="end-date-number">
                                  {surveyAnswersInfo?.surveyInfo.endDate ? (
                                    getDate(
                                      parseISO(
                                        surveyAnswersInfo?.surveyInfo?.endDate.toString()
                                      )
                                    )
                                  ) : (
                                    <span
                                      style={{
                                        transform: "translateY(50%)",
                                        fontSize: "0.9rem",
                                        width: "155px",
                                      }}
                                    >
                                      Assessment not started
                                    </span>
                                  )}
                                </div>
                                <div className="end-date-month-year">
                                  <span className="end-month">
                                    {surveyAnswersInfo?.surveyInfo?.endDate &&
                                      monthsHash?.[
                                        getMonth(
                                          parseISO(
                                            surveyAnswersInfo?.surveyInfo?.endDate.toString()
                                          )
                                        )
                                      ]}
                                  </span>
                                  <span className="end-year">
                                    {surveyAnswersInfo?.surveyInfo?.endDate &&
                                      getYear(
                                        parseISO(
                                          surveyAnswersInfo?.surveyInfo?.endDate.toString()
                                        )
                                      )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="supplier-view-survey-heading-cover">
                      <h4 className="heading-text">
                        {surveyAnswersInfo?.surveyInfo?.surveyName}
                      </h4>
                    </div>
                    <div className="supplier-view-survey-additionalinfo-description-cover">
                      <div className="supplier-view-survey-additionalinfo-description-wrapper">
                        <p className="supplier-view-survey-additionalinfo-description-text">
                          {
                            surveyAnswersInfo?.surveyInfo?.additionalInfo
                              ?.description
                          }
                        </p>
                      </div>
                    </div>
                    {surveyAnswersInfo?.surveyInfo?.isScoreEnable &&
                      surveyAnswersInfo?.surveyInfo?.additionalInfo
                        ?.showScoreInfo &&
                      surveyAnswersInfo?.surveyStatus !==
                        EnumSurveyAnswerStatus?.REJECTED &&
                      surveyAnswersInfo?.surveyScoreInfo && (
                        <div className="score-card-cover">
                          <div className="risk-cover">
                            <div
                              style={{
                                color: `${
                                  currentImpactColor[
                                    surveyAnswersInfo?.surveyScoreInfo?.impact
                                  ]
                                }`,
                                background: `${backgroundColorForImpact(
                                  surveyAnswersInfo?.surveyScoreInfo?.impact
                                )}`,
                                border: `${borderColorForImpact(
                                  surveyAnswersInfo?.surveyScoreInfo?.impact
                                )}`,
                                textTransform: "capitalize",
                                height: "30px",
                                width: "100%",
                                borderRadius: "5px",
                                lineHeight: "30px",
                                textAlign: "center",
                              }}
                            >
                              <span>
                                {surveyAnswersInfo?.surveyScoreInfo?.impact}

                                <span
                                  style={{
                                    paddingLeft: "5px",
                                  }}
                                >
                                  Risk
                                </span>
                              </span>
                            </div>
                          </div>
                          <div className="progress-bar-cover">
                            <div className="des">
                              {
                                <span>
                                  Assessment Score:
                                  {surveyAnswersInfo?.surveyScoreInfo?.score.toFixed(
                                    2
                                  )}
                                  /
                                  {
                                    surveyAnswersInfo?.surveyScoreInfo
                                      ?.totalMaxWeightage
                                  }
                                </span>
                              }
                            </div>
                            <div className="progress-bar">
                              <div
                                style={{
                                  width: `${
                                    isNaN(percentage) ? 0 : percentage
                                  }%`,
                                  backgroundColor: "#1EBF9C",
                                  height: "100%",
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      )}

                    <div className="note-cover">
                      <div className="note-wrapper">
                        <div className="header">Note & Guidance</div>
                        <div className="rules">
                          {notes?.map((ele, index) => {
                            return (
                              <div key={index} className="lines">
                                {ele.replace(regex, "")}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    <div className="supplier-view-question-inner-cover">
                      <div className="supplier-view-question-header-cover">
                        <div className="supplier-view-question-header-wrapper">
                          <h3 className="supplier-view-question-header-text">
                            Questions
                          </h3>
                          {taggedSurveyNotAnsweredNote && (
                            <div>
                              Note:
                              <span
                                style={{
                                  color: "red",
                                  paddingLeft: "5px",
                                  fontSize: "14px",
                                }}
                              >
                                {`${taggedSurveyNotAnsweredNote} (${surveyAnswersInfo.surveyInfo.baseSurvey.surveyName}) for submitting.`}
                              </span>
                            </div>
                          )}
                          {surveyAnswersInfo?.surveyInfo?.baseSurvey &&
                            getBaseSurveyAnswer && (
                              <div className="carry-forward-answer-toggle">
                                <span className="past-response-text">
                                  Past responses :
                                </span>
                                <Tippy
                                  content={`${
                                    isPastResponseView ? "Hide" : "View"
                                  } past response of ${
                                    surveyAnswersInfo.surveyInfo.baseSurvey
                                      .surveyName
                                  }`}
                                  placement="top-start"
                                  theme="light"
                                >
                                  <img
                                    style={{ cursor: "pointer" }}
                                    className="carry-forward-answer-image"
                                    src={
                                      isPastResponseView
                                        ? images.ToggleSwitchOn
                                        : images.ToggleSwitchOff
                                    }
                                    alt="carry-forward-answer-survey"
                                    onClick={() =>
                                      handlePastResponseViewChange()
                                    }
                                  />
                                </Tippy>
                              </div>
                            )}
                        </div>
                      </div>

                      {/* {Past response toggle note} */}
                      {isPastResponseView && (
                        <div className="past-response-note-cover">
                          <div className="past-response-note">
                            <img
                              src={images.noteCarryForward}
                              alt="note"
                              className="past-response-note-img"
                            />
                            <h3 className="past-response-note-header">
                              Note:{" "}
                            </h3>
                            <p className="past-response-note-detail">
                              The data shown below the data entry field is from
                              <span className="base-survey-name">{`${surveyAnswersInfo?.surveyInfo?.baseSurvey?.surveyName}`}</span>
                            </p>
                          </div>
                        </div>
                      )}

                      {/* if no question show image */}
                      {surveyAnswersInfo?.surveyInfo?.questionsInfo
                        ?.questionOrder?.length === 0 && (
                        <div className="preview-empty-questions">
                          <img
                            className="no-questions-img"
                            src={images.NoCreateAndChoosequestion}
                            alt="preview no questions"
                          />
                          <p className="prview-no-questions-text">
                            <span>No Questions Created</span>
                          </p>
                        </div>
                      )}
                      {reducerState?.questionIdsToRender?.map(
                        (questionId: string, index) => {
                          return (
                            <div
                              ref={(el) =>
                                (questionIdRefs.current[questionId] = el)
                              }
                              key={questionId}
                              className={`supplier-view-question-cover ${
                                surveyAnswers?.[questionId]?.notApplicableInfo
                                  ?.isNotApplicable
                                  ? "disabled"
                                  : "enabled"
                              }`}
                            >
                              <div className="supplier-view-question">
                                <div className="supplier-view-question-index-number">
                                  <span className="question-index-number">
                                    {questionIndexMap[questionId]}.
                                    {/* {index + 1}. */}
                                  </span>
                                </div>
                                <div className="supplie-view-question-question-text">
                                  <span
                                    className="question-text"
                                    dangerouslySetInnerHTML={{
                                      __html: DOMPurify.sanitize(
                                        questionObjVariable?.[questionId]
                                          ?.question
                                      ),
                                    }}
                                  ></span>
                                  {questionObjVariable?.[questionId]?.validation
                                    ?.mandatory?.isMandatory && (
                                    <span
                                      style={{
                                        color: "red",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      *
                                    </span>
                                  )}
                                  {questionObjVariable?.[questionId]?.toolTip &&
                                    cleanText(
                                      questionObjVariable?.[questionId]?.toolTip
                                    )?.length! > 0 && (
                                      <Tippy
                                        content={
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: DOMPurify.sanitize(
                                                questionObjVariable?.[
                                                  questionId
                                                ]?.toolTip
                                              ),
                                            }}
                                          ></span>
                                        }
                                        placement="top"
                                        theme="light"
                                      >
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          <img
                                            src={images.InformationTooltip}
                                            width={14}
                                          />
                                        </span>
                                      </Tippy>
                                    )}
                                </div>
                              </div>
                              {/* {questionObjVariable?.[questionId]?.validation
                                ?.mandatory?.isMandatory && (
                                <span className="question-text-is-madatory">
                                  This question is mandatory
                                </span>
                              )} */}
                              {questionObjVariable?.[questionId]
                                .description && (
                                <div className="supplier-view-description">
                                  {questionObjVariable?.[
                                    questionId
                                  ]?.description.replace(regex, "")}
                                </div>
                              )}
                              <div className="theme-category-cover-box">
                                {questionObjVariable?.[questionId]?.labels!
                                  ?.length > 0 && (
                                  <>
                                    <div className="question-library-questions-view-labels-preview">
                                      <span
                                        className="question-library-view-labels"
                                        onMouseEnter={() =>
                                          setIsHoveredLabel({ [index]: true })
                                        }
                                        onMouseLeave={() =>
                                          setIsHoveredLabel({
                                            [index]: false,
                                          })
                                        }
                                      >
                                        View Labels
                                      </span>
                                      {isHoveredLabel[index] &&
                                        questionObjVariable?.[questionId]
                                          ?.labels!?.length > 0 && (
                                          <div className="question-library-questions-view-label-hover-modal-main-container-preview">
                                            <div className="question-library-questions-view-label-hover-modal-header">
                                              All Labels
                                            </div>
                                            {questionObjVariable?.[
                                              questionId
                                            ]?.labels!.map(
                                              (
                                                label: string,
                                                index: number
                                              ) => (
                                                <div className="question-library-questions-view-label-hover-modal-label-list-show">
                                                  <div className="question-library-sl-numb">
                                                    {index + 1}.
                                                  </div>{" "}
                                                  <div className="question-library-labels-list">
                                                    {label}
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  </>
                                )}
                                {questionObjVariable?.[questionId]
                                  ?.templateType && (
                                  <Tippy
                                    content="Template"
                                    theme="light"
                                    placement="bottom"
                                  >
                                    {questionObjVariable?.[questionId]
                                      ?.templateType ===
                                    TemplateNameEnum.ILPA ? (
                                      <img src={images.ilpaQuestion} />
                                    ) : (
                                      <div className="template-type-tag">
                                        {questionObjVariable?.[questionId]
                                          ?.templateType ===
                                        TemplateNameEnum.MULTIPLES_ST
                                          ? TemplateNameEnum.MULTIPLES
                                          : questionObjVariable?.[questionId]
                                              ?.templateType}
                                      </div>
                                    )}
                                  </Tippy>
                                )}
                                {questionObjVariable?.[questionId]
                                  ?.category && (
                                  <div className="category-cover">
                                    {truncateString(
                                      questionObjVariable?.[questionId]
                                        ?.category?.name ||
                                        questionObjVariable?.[questionId]
                                          ?.category,
                                      30
                                    )}
                                  </div>
                                )}
                                {questionObjVariable?.[questionId]?.theme && (
                                  <div className="theme-cover">
                                    {truncateString(
                                      questionObjVariable?.[questionId]?.theme,
                                      30
                                    )}
                                  </div>
                                )}
                              </div>
                              <div className="supplier-view-question-type-component-render-cover">
                                {/* render ui based on type  */}
                                {renderQuestions(questionId)}
                              </div>
                              {/* {render Past response answer} */}
                              {surveyAnswersInfo?.surveyInfo?.baseSurvey &&
                                isPastResponseView && (
                                  <div className="past-response-tag-container">
                                    <img
                                      className="past-response-tag-img"
                                      src={images.taggedResponse}
                                      alt="past response tag"
                                    />
                                    <div className="content">
                                      <p className="past-response-tag-head">
                                        {`Tagged ${surveyAnswersInfo?.surveyInfo?.baseSurvey?.surveyName} answer`}
                                        :
                                      </p>

                                      <h2 className="past-response-tag-answer">
                                        {getBaseSurveyAnswer!?.surveyAnswers?.[
                                          questionId
                                        ]?.val ??
                                          (getBaseSurveyAnswer!
                                            ?.surveyAnswers?.[questionId]
                                            ?.notApplicableInfo?.isNotApplicable
                                            ? "NA"
                                            : "No Answer")}
                                      </h2>
                                    </div>
                                  </div>
                                )}
                              {/* render note and attachment based on status  */}
                              {surveyAnswers?.[questionId]?.comment &&
                                !isPreview &&
                                surveyAnswersInfo.surveyStatus !==
                                  EnumSurveyAnswerStatus?.COMPLETED && (
                                  <div className="note-wrapper">
                                    <div className="note-header">Note</div>

                                    <div className="note-content">
                                      {surveyAnswers?.[questionId]?.comment
                                        ?.charAt(0)
                                        .toUpperCase()}
                                      {surveyAnswers?.[
                                        questionId
                                      ]?.comment?.slice(1)}
                                    </div>
                                    {surveyAnswers?.[questionId]?.uploads!
                                      ?.length > 0 && (
                                      <>
                                        <Tippy
                                          content=" Please add if any comments or note to particular question."
                                          placement="top-start"
                                          theme="light"
                                        >
                                          <div className="edit-note-inner-cover">
                                            <span
                                              className={`note-gray ${
                                                surveyAnswers?.[questionId]
                                                  ?.notApplicableInfo
                                                  ?.isNotApplicable
                                                  ? "disabled"
                                                  : "enabled"
                                              }`}
                                              onClick={() => (
                                                dispatch({
                                                  type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                                                  payload: {
                                                    modalType:
                                                      EnumTypeTexts?.NOTE,
                                                    questionId,
                                                  },
                                                }),
                                                dispatch({
                                                  type: ActionKind.SET_NOTE_STATE_FROM_SURVEY_ANSWER,
                                                  payload: surveyAnswers,
                                                })
                                              )}
                                            >
                                              <img
                                                src={images.addButton}
                                                className="add-image"
                                              />
                                              Edit Note
                                            </span>
                                          </div>
                                        </Tippy>
                                      </>
                                    )}
                                  </div>
                                )}
                              {/* <div className="theme-category-cover">
                                {questionObjVariable?.[questionId]?.labels!
                                  ?.length > 0 && (
                                  <>
                                    <div className="question-library-questions-view-labels">
                                      <span
                                        className="question-library-view-labels"
                                        onMouseEnter={() =>
                                          setIsHoveredLabel({ [index]: true })
                                        }
                                        onMouseLeave={() =>
                                          setIsHoveredLabel({
                                            [index]: false,
                                          })
                                        }
                                      >
                                        View Labels
                                      </span>
                                    </div>
                                    {isHoveredLabel[index] &&
                                      questionObjVariable?.[questionId]?.labels!
                                        ?.length > 0 && (
                                        <div className="question-library-questions-view-label-hover-modal-main-container">
                                          <div className="question-library-questions-view-label-hover-modal-header">
                                            All Labels
                                          </div>
                                          {questionObjVariable?.[
                                            questionId
                                          ]?.labels!.map(
                                            (label: string, index: number) => (
                                              <div className="question-library-questions-view-label-hover-modal-label-list-show">
                                                <div className="question-library-sl-numb">
                                                  {index + 1}.
                                                </div>{" "}
                                                <div className="question-library-labels-list">
                                                  {label}
                                                </div>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      )}
                                  </>
                                )}
                                {questionObjVariable?.[questionId]
                                  ?.templateType && (
                                  <Tippy
                                    content="Template"
                                    theme="light"
                                    placement="bottom"
                                  >
                                    {questionObjVariable?.[questionId]
                                      ?.templateType ===
                                    TemplateNameEnum.ILPA ? (
                                      <img src={images.ilpaQuestion} />
                                    ) : (
                                      <div className="template-type-tag">
                                        {questionObjVariable?.[questionId]
                                          ?.templateType ===
                                        TemplateNameEnum.MULTIPLES_ST
                                          ? TemplateNameEnum.MULTIPLES
                                          : questionObjVariable?.[questionId]
                                              ?.templateType}
                                      </div>
                                    )}
                                  </Tippy>
                                )}
                                {questionObjVariable?.[questionId]
                                  ?.category && (
                                  <div className="category-cover">
                                    {truncateString(
                                      questionObjVariable?.[questionId]
                                        ?.category?.name ||
                                        questionObjVariable?.[questionId]
                                          ?.category,
                                      30
                                    )}
                                  </div>
                                )}
                                {questionObjVariable?.[questionId]?.theme && (
                                  <div className="theme-cover">
                                    {truncateString(
                                      questionObjVariable?.[questionId]?.theme,
                                      30
                                    )}
                                  </div>
                                )}
                              </div> */}

                              {surveyAnswers?.[questionId]?.uploads!?.length >
                                0 && (
                                <div className="note-wrapper">
                                  <div className="note-header">Attachment</div>
                                  <div className="note-content">
                                    <div className="attachment-cover">
                                      {surveyAnswers?.[
                                        questionId
                                      ]?.uploads!?.map(
                                        (addedData: any, index: number) => (
                                          <div
                                            className="attachment-file-container"
                                            key={addedData?.key}
                                          >
                                            <div className="attachment-image">
                                              <img
                                                src={showFileSvg(addedData)}
                                                width={27}
                                                alt=""
                                              />
                                            </div>
                                            <div
                                              className="attachment-name-container"
                                              style={
                                                surveyAnswersInfo.surveyStatus !==
                                                EnumSurveyAnswerStatus?.COMPLETED
                                                  ? {
                                                      borderRight:
                                                        "1px solid #d6d6d6",
                                                    }
                                                  : {
                                                      borderRight: "none",
                                                    }
                                              }
                                            >
                                              <Tippy
                                                theme="light"
                                                content={
                                                  <>
                                                    <div
                                                      style={{
                                                        fontWeight: "500",
                                                      }}
                                                    >
                                                      File name :
                                                    </div>
                                                    <div>{addedData.name}</div>
                                                  </>
                                                }
                                                disabled={
                                                  addedData.name.length < 39
                                                }
                                              >
                                                <div className="file-name">
                                                  {truncateString(
                                                    addedData.name,
                                                    40
                                                  )}
                                                </div>
                                              </Tippy>
                                            </div>
                                            {
                                              <span
                                                onClick={() => {
                                                  surveyAnswersInfo.surveyStatus !==
                                                    EnumSurveyAnswerStatus?.COMPLETED &&
                                                    confirmDeleteFile(
                                                      addedData?.Key,
                                                      questionId
                                                    );
                                                }}
                                                className="delete-attached-file"
                                              >
                                                <img
                                                  src={
                                                    surveyAnswersInfo.surveyStatus !==
                                                    EnumSurveyAnswerStatus?.COMPLETED
                                                      ? images.Delete
                                                      : images.download
                                                  }
                                                  height={18}
                                                />
                                              </span>
                                            }
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="note-and-attachment-cover">
                                <div className="note-and-attachment-wrapper">
                                  {surveyAnswersInfo.surveyStatus !==
                                    EnumSurveyAnswerStatus?.COMPLETED &&
                                    (!surveyAnswers?.[questionId]?.uploads!
                                      ?.length ||
                                      !surveyAnswers?.[questionId]?.comment
                                        ?.length) &&
                                    surveyAnswersInfo?.surveyInfo?.questionsInfo
                                      ?.questionObj[questionId]
                                      ?.enableNoteMandatory && (
                                      <Tippy
                                        content=" Please add if any comments or note to particular question."
                                        placement="top-start"
                                        theme="light"
                                        disabled={
                                          surveyAnswers?.[questionId]
                                            ?.notApplicableInfo?.isNotApplicable
                                        }
                                      >
                                        <div
                                          className="note-inner-cover"
                                          style={{
                                            borderBottom: `${
                                              surveyAnswers?.[questionId]
                                                ?.notApplicableInfo
                                                ?.isNotApplicable
                                                ? "1px solid #7c7c7c"
                                                : "1px solid #2863ff"
                                            }
                                              `,
                                          }}
                                        >
                                          <span
                                            className={`note-gray ${
                                              surveyAnswers?.[questionId]
                                                ?.notApplicableInfo
                                                ?.isNotApplicable
                                                ? "disabled"
                                                : "enabled"
                                            }`}
                                            onClick={() => (
                                              dispatch({
                                                type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                                                payload: {
                                                  modalType:
                                                    EnumTypeTexts?.NOTE,
                                                  questionId,
                                                },
                                              }),
                                              dispatch({
                                                type: ActionKind.SET_NOTE_STATE_FROM_SURVEY_ANSWER,
                                                payload: surveyAnswers,
                                              })
                                            )}
                                          >
                                            <img
                                              src={
                                                surveyAnswers?.[questionId]
                                                  ?.notApplicableInfo
                                                  ?.isNotApplicable
                                                  ? images.addNoteGray
                                                  : images.addButton
                                              }
                                              className="add-image"
                                            />
                                            Add Note
                                          </span>
                                        </div>
                                      </Tippy>
                                    )}
                                  {surveyAnswersInfo.surveyStatus !==
                                    EnumSurveyAnswerStatus?.COMPLETED &&
                                    surveyAnswersInfo?.surveyInfo?.questionsInfo
                                      ?.questionObj[questionId]
                                      ?.questionType !==
                                      EnumQuestionType.FILE &&
                                    surveyAnswersInfo?.surveyInfo?.questionsInfo
                                      ?.questionObj[questionId]
                                      ?.questionType !==
                                      EnumQuestionType.CUSTOM_FORM &&
                                    surveyAnswersInfo?.surveyInfo?.questionsInfo
                                      ?.questionObj[questionId]
                                      ?.enableAttachmentMandatory && (
                                      <Tippy
                                        content=" Please add if any files to particular question."
                                        placement="top-start"
                                        theme="light"
                                        disabled={
                                          surveyAnswers?.[questionId]
                                            ?.notApplicableInfo?.isNotApplicable
                                        }
                                      >
                                        <div
                                          className="attachment-cover"
                                          style={{
                                            borderBottom: surveyAnswers?.[
                                              questionId
                                            ]?.notApplicableInfo
                                              ?.isNotApplicable
                                              ? "1px solid #7c7c7c"
                                              : "1px solid #2863ff",
                                          }}
                                        >
                                          <div
                                            className="attachment-gray"
                                            style={{
                                              color: surveyAnswers?.[questionId]
                                                ?.notApplicableInfo
                                                ?.isNotApplicable
                                                ? "#7c7c7c"
                                                : "#2863ff",
                                              pointerEvents: surveyAnswers?.[
                                                questionId
                                              ]?.notApplicableInfo
                                                ?.isNotApplicable
                                                ? "none"
                                                : "all",
                                            }}
                                            onClick={() =>
                                              dispatch({
                                                type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                                                payload: {
                                                  modalType:
                                                    EnumTypeTexts?.ATTACHMENTS,
                                                  questionId,
                                                },
                                              })
                                            }
                                          >
                                            Add Attachment{" "}
                                            {reducerState?.uploadedFiles?.get(
                                              questionId
                                            )!?.selectedFiles?.length > 0 && (
                                              <div className="total-count">
                                                {
                                                  reducerState?.uploadedFiles?.get(
                                                    questionId
                                                  )!?.selectedFiles?.length
                                                }
                                              </div>
                                            )}
                                          </div>
                                          {/* )} */}
                                        </div>
                                      </Tippy>
                                    )}
                                  <div
                                    className="clear-button-cover"
                                    style={{ width: "96%" }}
                                  >
                                    {(surveyAnswers?.[questionId] ||
                                      (questionObjVariable[questionId]
                                        .questionType === "file_upload" &&
                                        reducerState.uploadedFiles.get(
                                          questionId
                                        )?.selectedFiles.length! > 0)) && (
                                      <div className="supplier-view-question-clear-answer-cover">
                                        {surveyAnswersInfo?.surveyStatus !==
                                          EnumSurveyAnswerStatus?.COMPLETED && (
                                          <div
                                            onClick={() =>
                                              handleClearAnswer(
                                                questionId,
                                                surveyAnswersInfo?.surveyInfo
                                                  ?.questionsInfo?.questionObj[
                                                  questionId
                                                ]?.questionType
                                              )
                                            }
                                          >
                                            <span className="clear-answer-text">
                                              Clear answer
                                            </span>

                                            <span className="clear-answer-img-cover">
                                              <img
                                                className="clear-answer-img"
                                                src={images.ClearAnswerIcon}
                                                alt="clear answer"
                                              />
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {surveyAnswersInfo?.surveyInfo?.questionsInfo
                                ?.questionObj?.[questionId]
                                ?.enableNotApplicable && (
                                <div className="not-applicable-cover">
                                  <div className="image-and-text-cover">
                                    <img
                                      style={{ cursor: "pointer" }}
                                      className="not-applicable-image"
                                      src={
                                        surveyAnswers?.[questionId]
                                          ?.notApplicableInfo?.isNotApplicable
                                          ? images.ToggleSwitchOn
                                          : images.ToggleSwitchOff
                                      }
                                      alt="not-applicable"
                                      onClick={() =>
                                        !isPreview &&
                                        surveyAnswersInfo.surveyStatus !==
                                          EnumSurveyAnswerStatus?.COMPLETED &&
                                        handleNotApplicableToggle(
                                          questionId,
                                          surveyAnswersInfo?.surveyInfo
                                            ?.questionsInfo?.questionObj[
                                            questionId
                                          ]?.questionType
                                        )
                                      }
                                    />
                                    <span className="not-applicable-text">
                                      Mark this question as not applicable
                                    </span>
                                  </div>
                                  {surveyAnswers?.[questionId]
                                    ?.notApplicableInfo?.isNotApplicable && (
                                    <UpdaptTextArea
                                      styles={{
                                        input: {
                                          width: "650px",
                                        },
                                      }}
                                      onChange={(e) => {
                                        surveyAnswersInfo.surveyStatus !==
                                          EnumSurveyAnswerStatus?.COMPLETED &&
                                          handleNotApplicableNote(
                                            e,
                                            questionId
                                          );
                                      }}
                                      placeholder="Please provide the reason for marking this question as not applicable."
                                      value={
                                        surveyAnswers?.[questionId]
                                          ?.notApplicableInfo?.note
                                      }
                                      disabled={
                                        surveyAnswersInfo.surveyStatus ===
                                        EnumSurveyAnswerStatus?.COMPLETED
                                      }
                                    />
                                  )}
                                </div>
                              )}
                              {(questionObjVariable?.[questionId]?.validation
                                ?.mandatory?.isMandatory ||
                                questionObjVariable[questionId]
                                  ?.attachmentMandatoryInfo
                                  ?.enableForQuestion ||
                                questionObjVariable[questionId]
                                  ?.enableNoteMandatory ||
                                (questionObjVariable[questionId]
                                  ?.attachmentMandatoryInfo!
                                  ?.enableForOptions &&
                                  check(
                                    questionObjVariable[questionId]
                                      ?.attachmentMandatoryInfo!.options
                                  ).visible)) && (
                                <div className="question-text-is-mandatory">
                                  <div
                                    className={
                                      `question-text-mandatory`
                                      //   ${
                                      //   assessmentType === AssessmentType.ACTIVE &&
                                      //   (userDetails.userRole === RoleTypeEnum.SUPER_ADMIN ||
                                      //     userDetails.userRole === RoleTypeEnum.ADMIN)
                                      //     ? "active"
                                      //     : "past"
                                      // }
                                      // `
                                    }
                                  >
                                    {/* {generateMessage(
                                      questionId,
                                      questionObjVariable?.[questionId]
                                        ?.validation?.mandatory?.isMandatory ??
                                        false,
                                      questionObjVariable[questionId]
                                        ?.attachmentMandatoryInfo
                                        ?.enableForQuestion ?? false,
                                      questionObjVariable[questionId]
                                        ?.attachmentMandatoryInfo
                                        ?.enableForOptions ?? false,
                                      questionObjVariable[questionId]
                                        ?.attachmentMandatoryInfo!?.options ??
                                        [],
                                      questionObjVariable[questionId]
                                        ?.enableNoteMandatory ?? false,
                                      questionObjVariable[questionId]
                                        ?.noteMandatoryInfo!?.options ?? [],

                                      questionObjVariable[questionId]
                                        ?.noteMandatoryInfo
                                        ?.enableForQuestion ?? false,

                                      questionObjVariable[questionId]
                                        ?.noteMandatoryInfo?.enableForOptions ??
                                        false
                                    )} */}
                                    {generateMessage(
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.validation?.mandatory?.isMandatory ??
                                        false,
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.attachmentMandatoryInfo
                                        ?.enableForQuestion ?? false,
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.attachmentMandatoryInfo
                                        ?.enableForOptions ?? false,
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.attachmentMandatoryInfo!?.options ??
                                        [],
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.noteMandatoryInfo!?.options ?? [],
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.enableNoteMandatory ?? false,
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.optionInfo,
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.noteMandatoryInfo?.enableForQuestion ??
                                        false,
                                      surveyAnswersInfo?.surveyInfo
                                        ?.questionsInfo?.questionObj?.[
                                        questionId
                                      ]?.noteMandatoryInfo?.enableForOptions ??
                                        false
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                  {/* add note modal dialog */}
                  {reducerState.modalInfo.noteModalOpen && (
                    <Dialog
                      open={reducerState?.modalInfo?.noteModalOpen}
                      className="add-note-modal"
                      onClose={() =>
                        dispatch({
                          type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                          payload: {
                            modalType: EnumTypeTexts?.NOTE,
                          },
                        })
                      }
                      aria-labelledby="form-dalog-title"
                      PaperProps={{
                        style: {
                          width: "400px",
                          height: "350px",
                        },
                      }}
                    >
                      <DialogTitle className="note-dialog-header">
                        <div className="note-add-modal-title-conatiner">
                          <h4>Note</h4>
                          <span
                            className="note-close"
                            onClick={() =>
                              dispatch({
                                type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                                payload: {
                                  modalType: EnumTypeTexts?.NOTE,
                                },
                              })
                            }
                          >
                            {icons.cross}
                          </span>
                        </div>
                      </DialogTitle>
                      <Divider />
                      <DialogContent className="dialog-content-conatiner">
                        <div className="modal-content">
                          <div className="input-cover">
                            <textarea
                              className="input-textarea"
                              placeholder="Enter a Note"
                              onChange={(event) =>
                                !isPreview &&
                                surveyAnswersInfo.surveyStatus !==
                                  EnumSurveyAnswerStatus?.COMPLETED &&
                                !surveyAnswers?.[
                                  reducerState?.modalNoteAndAttQuestionId
                                ]?.notApplicableInfo?.isNotApplicable &&
                                handleChangeAddComment(event)
                              }
                              value={
                                reducerState?.noteState?.[
                                  reducerState?.modalNoteAndAttQuestionId
                                ] || ""
                              }
                              disabled={
                                isPreview ||
                                surveyAnswersInfo.surveyStatus ===
                                  EnumSurveyAnswerStatus?.COMPLETED
                              }
                            />
                          </div>
                        </div>
                      </DialogContent>
                      <DialogActions className="dialog-action-conatiner-cover">
                        <div className="dialog-action-conatiner-wrapper">
                          <div className="note-cancel-cover">
                            <button
                              className={
                                !isPreview &&
                                surveyAnswersInfo.surveyStatus !==
                                  EnumSurveyAnswerStatus?.COMPLETED
                                  ? "note-cancel is-preview-active-cancel"
                                  : "note-cancel is-preview-disabled-cancel"
                              }
                              onClick={() =>
                                !isPreview &&
                                surveyAnswersInfo.surveyStatus !==
                                  EnumSurveyAnswerStatus?.COMPLETED &&
                                handleChangeClearComment(
                                  reducerState?.modalNoteAndAttQuestionId
                                )
                              }
                            >
                              Clear
                            </button>
                          </div>
                          <div className="note-save-cover">
                            <button
                              className={
                                !isPreview &&
                                surveyAnswersInfo.surveyStatus !==
                                  EnumSurveyAnswerStatus?.COMPLETED
                                  ? "note-save is-preview-active-save"
                                  : "note-save is-preview-disabled-save"
                              }
                              onClick={() => (
                                handleNoteComment(
                                  reducerState.modalNoteAndAttQuestionId
                                ),
                                !isPreview &&
                                  surveyAnswersInfo.surveyStatus !==
                                    EnumSurveyAnswerStatus?.COMPLETED &&
                                  dispatch({
                                    type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                                    payload: {
                                      modalType: EnumTypeTexts?.NOTE,
                                    },
                                  })
                              )}
                            >
                              {surveyAnswers?.[
                                reducerState?.modalNoteAndAttQuestionId
                              ]?.comment
                                ? "Update"
                                : "Add"}
                            </button>
                          </div>
                        </div>
                      </DialogActions>
                    </Dialog>
                  )}
                  {/* add attachment modal dialog */}
                  {reducerState.modalInfo.attachmentModalOpen && (
                    <Dialog
                      open={reducerState?.modalInfo?.attachmentModalOpen}
                      className="attachment-add-section-modal"
                      onClose={() =>
                        dispatch({
                          type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                          payload: {
                            modalType: EnumTypeTexts?.ATTACHMENTS,
                          },
                        })
                      }
                      aria-labelledby="form-dalog-title"
                      PaperProps={{
                        style: {
                          width: "453px",
                          height: "452px",
                        },
                      }}
                    >
                      <DialogTitle className="attachment-dialog-header">
                        <div className="attachment-add-modal-title-conatiner">
                          <h4>Attachment</h4>
                          <span
                            className="attachments-close"
                            onClick={() =>
                              dispatch({
                                type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                                payload: {
                                  modalType: EnumTypeTexts?.ATTACHMENTS,
                                },
                              })
                            }
                          >
                            {icons.cross}
                          </span>
                        </div>
                      </DialogTitle>
                      <DialogContent className="attachments-dialog-content-conatiner">
                        <div className="attachments-modal-content-wrapper">
                          <div className="attachments-modal-left-main-cover">
                            <div className="attachments-input-cover">
                              <input
                                type="file"
                                className="file-input"
                                id="file-upload"
                                multiple
                                style={{ display: "none" }}
                                onChange={(event) =>
                                  !isPreview &&
                                  surveyAnswersInfo.surveyStatus !==
                                    EnumSurveyAnswerStatus?.COMPLETED &&
                                  !surveyAnswers?.[
                                    reducerState?.modalNoteAndAttQuestionId
                                  ]?.notApplicableInfo?.isNotApplicable &&
                                  dispatch({
                                    type: ActionKind.HANDLE_FILE_CHANGE,
                                    payload: {
                                      files: event.currentTarget.files,
                                    },
                                  })
                                }
                                disabled={
                                  isPreview ||
                                  surveyAnswersInfo.surveyStatus ===
                                    EnumSurveyAnswerStatus?.COMPLETED
                                }
                              />
                            </div>
                            <div className="attachment-label-cover">
                              <label
                                htmlFor="file-upload"
                                className="file-upload-label"
                              >
                                <div className="upload-image">
                                  <img
                                    className="cloud-upload-file"
                                    src={images.responseUpload}
                                    alt="cloud-upload"
                                  />
                                </div>
                                <div className="upload-content">
                                  Browse file{" "}
                                </div>
                              </label>
                            </div>
                            <div className="attachment-left-added-file-cover">
                              {reducerState?.uploadedFiles?.get(
                                reducerState?.modalNoteAndAttQuestionId
                              )?.selectedFiles.length! > 0 ? (
                                <div className="files-added-left-cover">
                                  <div className="left-uploaded">
                                    {reducerState?.uploadedFiles
                                      .get(
                                        reducerState?.modalNoteAndAttQuestionId
                                      )!
                                      .selectedFiles.map(
                                        (addedData: any, index: number) => (
                                          <div
                                            key={index}
                                            className="uploaded-files"
                                          >
                                            <Tippy
                                              content={
                                                <>
                                                  <div>File name:</div>
                                                  <span>{addedData?.name}</span>
                                                </>
                                              }
                                              disabled={
                                                addedData?.name?.length < 29
                                              }
                                              theme={"light"}
                                            >
                                              <div className="files">
                                                {truncateString(
                                                  addedData?.name,
                                                  30
                                                )}{" "}
                                                &nbsp;{" "}
                                                <span
                                                  style={{
                                                    color: "#858585",
                                                  }}
                                                >
                                                  (
                                                  {(
                                                    addedData?.size / 1024
                                                  ).toFixed(2)}
                                                  KB)
                                                </span>
                                              </div>
                                            </Tippy>
                                            <div
                                              className="cancel-button"
                                              onClick={() => {
                                                removeAttachedFile(
                                                  addedData?.name
                                                );
                                              }}
                                            >
                                              <img src={images.UploadClear} />
                                            </div>
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                              ) : (
                                <div className="left-no-files-added">
                                  <div>
                                    <img src={images.attachmentUpload} />
                                  </div>
                                  <div> No files attached</div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </DialogContent>
                      <DialogActions className="attachments-dialog-action-conatiner-cover">
                        <div className="attachments-dialog-action-conatiner-wrapper">
                          <UpdaptButton
                            variant="secondary-button-cancel"
                            size="md"
                            children="Cancel"
                            onClick={() =>
                              dispatch({
                                type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                                payload: {
                                  modalType: EnumTypeTexts.ATTACHMENTS,
                                },
                              })
                            }
                          />
                          <UpdaptButton
                            variant="primary-button"
                            size="md"
                            children="Add"
                            onClick={() => {
                              dispatch({
                                type: ActionKind?.HANDLE_NOTE_AND_ATTACH_MODAL,
                                payload: {
                                  modalType: EnumTypeTexts.ATTACHMENTS,
                                },
                              });
                            }}
                            disabled={isPreview}
                          />
                        </div>
                      </DialogActions>
                    </Dialog>
                  )}
                  <div className="supplier-view-save-btn-cover">
                    <div
                      className={
                        surveyAnswersInfo.surveyStatus !==
                          EnumSurveyAnswerStatus?.COMPLETED &&
                        differenceInDaysCalcultor(
                          surveyAnswersInfo?.surveyInfo?.endDate
                        ) > 0 &&
                        !isPreview &&
                        !reducerState.numberQuesHash?.size
                          ? "supplier-view-draft-cover enabled"
                          : "supplier-view-draft-cover disabled"
                      }
                      onClick={() => {
                        surveyAnswersInfo?.surveyStatus !==
                          EnumSurveyAnswerStatus?.COMPLETED &&
                          differenceInDaysCalcultor(
                            surveyAnswersInfo?.surveyInfo?.endDate
                          ) > 0 &&
                          !isPreview &&
                          !reducerState.numberQuesHash?.size &&
                          SaveAsDraft();
                      }}
                    >
                      <div>Save as draft</div>
                    </div>
                    <div
                      onClick={() => {
                        surveyAnswersInfo.surveyStatus !==
                          EnumSurveyAnswerStatus?.COMPLETED &&
                          differenceInDaysCalcultor(
                            surveyAnswersInfo?.surveyInfo?.endDate
                          ) > 0 &&
                          !isPreview &&
                          !taggedSurveyNotAnsweredNote.length &&
                          !reducerState.numberQuesHash?.size &&
                          confirmSubmit();
                      }}
                      className={
                        surveyAnswersInfo?.surveyStatus !==
                          EnumSurveyAnswerStatus?.COMPLETED &&
                        differenceInDaysCalcultor(
                          surveyAnswersInfo?.surveyInfo?.endDate
                        ) > 0 &&
                        !isPreview &&
                        !taggedSurveyNotAnsweredNote.length &&
                        !reducerState.numberQuesHash?.size
                          ? "supplier-view-save-cover enabled"
                          : "supplier-view-save-cover disabled"
                      }
                    >
                      <div>Submit</div>
                    </div>
                  </div>
                </>
              )}
              {surveyAnswersInfo?.activated &&
                surveyAnswersInfo?.surveyInfo?.endDate &&
                differenceInDaysCalcultor(
                  surveyAnswersInfo?.surveyInfo?.endDate
                ) === 0 && <SurveyExpirationPage />}
              {!surveyAnswersInfo?.activated && <DeactivatePage />}
            </div>
          ) : (
            <>
              {
                <Navigate
                  replace
                  to="thankyou"
                  state={{ status: surveyAnswersInfo.surveyStatus }}
                />
              }
            </>
          )}
        </>
      )}
    </>
  );
}

export default SupplierView;
